export default "__VITE_ASSET__DKtx5uD9__"